import styled from 'styled-components';

export const Wrapper = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5 {
    * {
      font-size: inherit;
    }
  }
  * {
    margin-bottom: 0;
  }
  * + * {
    margin-top: 26px;
  }
  p {
    color: ${({ theme }) => theme.colors.grey.scarpaFlow};
    line-height: 2em;
    font-size: 18px;
  }
`;
